import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { useVirtualConversation } from "../hooks/useVirtualConversation";
import { ChatButton } from "./common/ChatButton";

type ActionButtonType = "chat" | "feedback" | "report_bug" | "copilot_action";

const getActionButtonText = (text: ActionButtonType) => {
  switch (text) {
    case "chat":
      return t("help_widget.home_page.ask_question");
    case "report_bug":
      return t("help_widget.home_page.report_bug");
    case "feedback":
      return t("help_widget.home_page.give_feedback");
    case "copilot_action":
      return t("help_widget.home_page.perform_an_action");
  }
};

export const FeedBackCtaButtons = ({
  disabled,
  markConversationAsClosed,
}: {
  disabled: boolean;
  markConversationAsClosed: () => void;
}) => {
  const { currentCommunitySettings, isLoading: isLoadingPunditUserContext } =
    usePunditUserContext();
  const isCopilotActionsEnabled =
    !isLoadingPunditUserContext &&
    currentCommunitySettings?.help_widget_copilot_actions_enabled;

  const { startVirtualConversation } = useVirtualConversation();

  const handleClick = (text: ActionButtonType) => {
    markConversationAsClosed();
    startVirtualConversation(text);
  };

  return (
    <div className="flex w-full flex-col items-center gap-2">
      <div className="flex w-full gap-2">
        <ChatButton
          label={getActionButtonText("chat")}
          event="chat"
          preferred={false}
          selected={null}
          setSelected={() => {}}
          onClick={() => handleClick("chat")}
          disabled={disabled}
        />
        <ChatButton
          label={getActionButtonText("report_bug")}
          event="report_bug"
          preferred={false}
          selected={null}
          setSelected={() => {}}
          onClick={() => handleClick("report_bug")}
          disabled={disabled}
        />
      </div>
      <div className="flex w-full gap-2">
        <ChatButton
          label={getActionButtonText("feedback")}
          event="feedback"
          preferred={false}
          selected={null}
          setSelected={() => {}}
          onClick={() => handleClick("feedback")}
          disabled={disabled}
        />
        {isCopilotActionsEnabled && (
          <ChatButton
            label={getActionButtonText("copilot_action")}
            event="copilot_action"
            preferred={false}
            selected={null}
            setSelected={() => {}}
            onClick={() => handleClick("copilot_action")}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};
